import { BrightcoveVideo } from "@components/Blocks/BrightcoveVideo/BrightcoveVideo";
import {
  MediaVariant,
  type Variant,
} from "@components/Layouts/HomePageStoryPackages/MediaPackages/types/MediaVariant.d";

export type VideoDialogProps = {
  videoDialog: {
    visible: boolean;
    source: string;
    variant?: Variant;
  };
  handleOnClickCloseDialog: () => void;
};

/**
 * VideoDialog
 * Description: [Brightcove video dialog component that displays
 * video player in a dialog box. Used in homepage with disabled fullscreen.]
 * @param props - The props required by the component.
 * @returns The rendered video dialog component
 */
export default function VideoDialog({
  videoDialog,
  handleOnClickCloseDialog,
}: VideoDialogProps) {
  const { visible, source, variant } = videoDialog;

  const isRingkas = variant === MediaVariant.RINGKAS;
  const dialogWidth = isRingkas
    ? "w-[280px] md:w-[300px]"
    : "w-full md:w-[520px]";
  const playerStyle = isRingkas ? "!aspect-[206/366]" : "";
  return (
    <>
      <div
        className={`fixed bottom-4 right-0 md:right-4 p-2 z-50 ${dialogWidth} ${visible ? "block" : "hidden"}`}
      >
        <div className="relative">
          <BrightcoveVideo
            videoId={source}
            smallWidget={true}
            playerStyle={playerStyle}
            disableFullscreen
          />
        </div>
        <div className="z-10 absolute top-0 right-0 flex items-center justify-center w-8 h-8 p-1 rounded-full bg-black-500">
          <button
            onClick={handleOnClickCloseDialog}
            id="close"
            className="text-text-inverse text-sm outline-none focus:outline-none"
          >
            X
          </button>
        </div>
      </div>
    </>
  );
}
